module.exports = __webpack_public_path__ + "static/flags/BS-b48f83468143a84a5ba826e4ab9beae7.gif";